import { useEffect } from "react";

export function SEO({ title, description, canonical, image, ogImage }) {
  useEffect(() => {
    // Set document title
    if (title) {
      document.title = title;
    }

    const setMetaTag = (attrName, attrValue, content) => {
      let meta = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (content) {
        if (!meta) {
          meta = document.createElement("meta");
          meta.setAttribute(attrName, attrValue);
          document.head.appendChild(meta);
        }
        meta.setAttribute("content", content);
      } else if (meta) {
        meta.remove();
      }
    };

    // Update meta description & OG/Twitter description
    if (description) {
      setMetaTag("name", "description", description);
      setMetaTag("property", "og:description", description);
      setMetaTag("name", "twitter:description", description);
    }

    // OG & Twitter title
    if (title) {
      setMetaTag("property", "og:title", title);
      setMetaTag("name", "twitter:title", title);
    }

    // OG & Twitter image
    const finalImage = ogImage !== undefined ? ogImage : image;
    setMetaTag("property", "og:image", finalImage || "");
    setMetaTag("name", "twitter:image", finalImage || "");

    if (finalImage) {
      setMetaTag("name", "twitter:card", "summary_large_image");
    }

    // Update canonical link
    if (canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (!linkCanonical) {
        linkCanonical = document.createElement("link");
        linkCanonical.setAttribute("rel", "canonical");
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.setAttribute("href", canonical);
    }
  }, [title, description, canonical, image, ogImage]);

  return null;
}
